import BaseTab from "./styled";
export default BaseTab;